import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import PaymentStatus from "./PaymentStatus";
import { recurringApi, sendPaymentByEmail, updateInvoice } from "../../../../../actions/product_details_action";
import { checkInvoiceData, emailValidation, TOAST_ERROR, TOAST_SUCCESS, windowOpen } from "../../../../../utils";
import ShareByEmailPopup from "../../Transactions/Component/Modals/ShareByEmailPopup";
import { getUseronboardingInfo } from "../../../../../actions/loginActions";
import { closePricingModal } from "../../../../../utils/close_modal";
import './modal.scss';

const popUpMsg = {
    title: "Share Payment Link By Email",
    subTitle: "Send the Payment Link to the account's owner. Enter the email id to share the link directly with them",
    placeholder: `support@socialwalls.com`,
    btnText: "Share Payment Link"
}

const UpgradeModal = ({ details, setUpgradeDetails, paymentAction, getAnotherPlan, failedPaymentUrl, failedPaymentStatus, billingcycle, navigate }) => {
    const { showDetails, data, type } = details;
    const [loading, setLoading] = useState(false);
    const [failStatus, setFailStatus] = useState(false);
    const [coupData, setCoupData] = useState({
        value: "",
        show: false,
        infoType: 0,
        errorMsg: "",
        request: false,
        couponValue: "",
        applied: false
    })
    const [shareEmail, setShareEmail] = useState({
        data: "",
        errorMsg: null
    })
    const dispatch = useDispatch();

    const initiatePayment = () => {
        setLoading(true);
        paymentAction(coupData.couponValue, (data) => {
            if (data) {
                let type = 3; // failed payment
                if (data?.subscriptionUpdatedStatus) type = 2; // success payment
                dispatch(updateInvoice(navigate));
                setFailStatus(type == 3);
                setUpgradeDetails(prev => ({ ...prev, data, type, showDetails: true }));
            }
            setLoading(false);
        })
    }
    const onHide = () => loading ? {} : updateUserData(() => setUpgradeDetails(prev => ({ ...prev, showDetails: false })));

    const submitEmail = () => {
        const emailId = shareEmail.data;
        if (!emailId?.trim()) setShareEmail((prev) => ({ ...prev, errorMsg: "This field is required" }));
        else if (emailValidation(emailId)) {
            setLoading(true);
            sendPaymentByEmail(emailId, failedPaymentUrl).then(response => {
                const { responseMessage, responseCode } = response.data;
                if (responseCode == 200) {
                    setLoading(false);
                    setTimeout(onHide, 100);
                    TOAST_SUCCESS(responseMessage);
                    setShareEmail({ data: "", errorMsg: null });
                }
            }).catch(error => {
                setLoading(false);
                TOAST_ERROR(error?.response?.data?.responseMessage ?? "");
            });
        } else setShareEmail((prev) => ({ ...prev, errorMsg: "Invalid Email" }));
    }

    const applyCupon = () => {
        const { value, applied } = coupData;
        if (!applied) {
            if (!value) setCoupData(pre => ({ ...pre, infoType: 1, errorMsg: "This field is required", couponValue: "" }));
            else {
                setCoupData(pre => ({ ...pre, request: true }));
                recurringApi({
                    billingcycle,
                    couponCode: value,
                    planId: data.planId,
                    planPending: failedPaymentStatus ? 1 : 0
                }).then(res => {
                    const { responseData, responseMessage } = res.data;
                    if (Object.keys(responseData).length > 0) {
                        const type = responseData?.isCouponApplied ? 2 : 1;
                        if (type == 2) setUpgradeDetails(prev => ({ ...prev, data: { ...data, ...responseData } }))
                        setCoupData(pre => ({ ...pre, infoType: type, errorMsg: responseMessage ?? '', couponValue: type == 2 ? value : "", applied: type == 2, request: false }));
                    }
                }).catch(ex => {
                    setCoupData(pre => ({ ...pre, infoType: 1, errorMsg: ex?.response?.data?.responseMessage ?? "", couponValue: "", request: false }));
                })
            }
        }
    }

    const updateUserData = (cbAction) => {
        if(type == 3){
            dispatch(getUseronboardingInfo((isPlanExpire) => {
                if (isPlanExpire) {
                    closePricingModal(dispatch);
                    localStorage.setItem('plan_exceeded', true);
                    navigate(`/widget/wall/extrawallfeeds`)
                }
                if(cbAction) cbAction()
            }, false));
        }else if(cbAction) cbAction()
    }

    useEffect(() => {
        if (type == 3 && failStatus && failedPaymentStatus == false) {
            onHide();
            setFailStatus(false);
        }
    }, [failedPaymentStatus])

    return type == 6 ? <ShareByEmailPopup shareAccount={showDetails} emails={shareEmail.data} handleEmail={(e) => setShareEmail((prev) => ({ ...prev, data: e.target.value, errorMsg: null }))} errorShareAccount={shareEmail.errorMsg} ValidateEmails={submitEmail} isSharingEmail={loading} openShareAccount={onHide} modalData={popUpMsg} /> : type != 1 ? <PaymentStatus {...{ details, onHide, loading, paymentAction: initiatePayment, getAnotherPlan, shareEmailPop: () => setUpgradeDetails(prev => ({ ...prev, type: 6, showDetails: true })), updateUserData }}  /> : <Modal show={showDetails}
        onHide={onHide}
        backdrop="static"
        keyboard={false}
        className="upgrade-modal"
        aria-labelledby="contained-modal-title-vcenter"
        centered  size="lg">
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
            <div className="" key={`${data.proratedAmount ?? 0}-${coupData.couponValue}`}>
                <div className="upgrade-title-section text-center">
                    <h2>You're switching your plan</h2>
                    <p>We will attempt to charge your existing linked card for upgrade. If you wish to update your card, {data?.updateSubscriptionLink ? <span onClick={() => windowOpen(data?.updateSubscriptionLink ?? "")}>click here</span> : null}</p>
                </div>
                <div className="upgrade-plans mt-5" >
                    <div className="row align-items-end">
                        <div className="col-md-6 col-12 mb-md-0 mb-3 pe-md-0">
                            <Planbox isNewPlan={false} planDetails={data} />
                        </div>
                        <div className="col-md-6 col-12 ps-md-0">
                            <Planbox isNewPlan={true} planDetails={data} />
                        </div>
                    </div>
                    <div className="mt-4 mb-5 text-end coupon-code">
                        {coupData.show ? <div className="d-inline-block">
                            <div className="input-group">
                                <input name="code" id="codePost" className="form-control" value={coupData.value} placeholder="Enter Code Here" type="text" onChange={(e) => setCoupData(pre => ({ ...pre, value: e.target.value, infoType: 0, errorMsg: "", applied: e.target.value == coupData.couponValue }))} />
                                <div className={`input-group-append ${!coupData.value ? '' : 'btn-active'}`}>
                                    <Button variant="secondary" className={`${coupData.request ? 'spinner spinner-right disabled' : coupData.applied ? 'disabled' : ''}`} onClick={applyCupon}>Apply</Button>
                                </div>
                            </div>
                            {coupData.infoType > 0 ? <p className={`text-${coupData.infoType == 1 ? 'danger' : 'success'} text-start m-0`}>{coupData.errorMsg}</p> : null}
                        </div> : <p className="mb-0">Have a Coupon Code? <Button variant="link" className="text-primary p-0" onClick={() => setCoupData(pre => ({ ...pre, show: true }))}>Apply Here</Button></p>}

                    </div>
                </div>
                <div className="upgrade-confirm-area d-flex align-items-center">
                    <p className="m-0 position-relative">Your already paid amount will automatically be adjusted in the payable amount on Prorata basis.</p>
                    <button className={`btn btn-primary ${loading ? 'spinner spinner-right disabled' : ''} ml-2`} onClick={loading ? null : initiatePayment}>Confirm</button>
                </div>
            </div>
        </Modal.Body>
    </Modal>
}

export default UpgradeModal;
const Planbox = ({ isNewPlan, planDetails }) => {
    const { currentPlanName, currentPlanExpireAt, currentPlanPrice, currency, currentPlanBillingcycle, upgradedPlanName, upgradedAmount, remainingCurrentAmount, proratedAmount, totalDiscountAmounts } = planDetails;
    const currMonths = currentPlanBillingcycle == "Yearly" ? 12 : 1;
    const curSign = currency == "usd" ? '$' : '₹';
    return (
        <div className={`plan-box p-3 position-relative ${isNewPlan ? 'upgrade-plan' : 'current-plan'}`}>
            <div className="plan-top d-flex align-items-center justify-content-between">
                <span>{isNewPlan ? 'Upgrade To' : 'Current Plan'}</span>
                <h2>{isNewPlan ? upgradedPlanName : currentPlanName}</h2>
            </div>
            {isNewPlan ?
                <div className="plan-mid">
                    <div className="plan-row d-flex justify-content-between align-items-center">
                        <span className="plan-title">Plan Amount</span>
                        <span className="plan-price">{curSign}{upgradedAmount}</span>
                    </div>
                    <div className="plan-row d-flex justify-content-between align-items-center">
                        <span className="plan-title">Unused Amount of Current Plan</span>
                        <span className="plan-price">-{curSign}{Math.round(remainingCurrentAmount)}</span>
                    </div>
                    {totalDiscountAmounts ? <div className="plan-row d-flex justify-content-between align-items-center">
                        <span className="plan-title">Discount Amount</span>
                        <span className="plan-price">-{curSign}{Math.round(totalDiscountAmounts)}</span>
                    </div> : null}
                </div> :
                <div className="plan-mid">
                    <div className="plan-row d-flex justify-content-between align-items-center">
                        <span className="plan-price">{curSign}{currentPlanPrice * currMonths}</span>
                        <span className="plan-title">Exp.</span>
                    </div>
                    <div className="plan-row d-flex justify-content-between">
                        <span className="plan-subtitle">{currentPlanBillingcycle}</span>
                        <span className="plan-subtitle">{checkInvoiceData(currentPlanExpireAt * 1000, 'Do MMM YYYY')}</span>
                    </div>
                </div>
            }
            {isNewPlan ?
                <div className="payable-amount d-flex align-items-center justify-content-between">
                    <span>Payable Amount</span>
                    <strong>{curSign}{Math.round(proratedAmount)}</strong>
                </div> : null
            }
        </div>
    );
}